import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.set.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { ThemeSectionError } from 'components/ThemeSection';
/**
 * Throw an error if no theme is defined
 */

function checkTheme(theme) {
  if (!(theme !== null && theme !== void 0 && theme.globals)) {
    throw new ThemeSectionError();
  }
}

/**
 * Retrieve a responsive style prop's value.
 * If prop is not an array, it means it's not responsive and only needs to be
 * set at the base breakpoint (i.e. index === 0), so we return undefined for
 * any index larger than 0.
 */

function getValueByIndex(prop) {
  var index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  if (Array.isArray(prop)) {
    return prop[index];
  }
  if (index > 0) {
    return undefined;
  }
  return prop;
}
function getStylePropRules(
// Style prop configuration objects
stylePropConfig,
// Props that the component was called with
componentProps,
// If the passed prop is an array of responsive values, this
// number tells us which value to pick from the array
breakpointIndex) {
  var rules = {};
  stylePropConfig.forEach(function (entry) {
    var styleProp = componentProps[entry.styleProp];
    if (styleProp && typeof styleProp === 'function') {
      styleProp = styleProp(componentProps.theme);
    }
    var stylePropValue = getValueByIndex(styleProp, breakpointIndex);
    if ('getRules' in entry && typeof entry.getRules === 'function' && stylePropValue !== undefined) {
      var rulesToAdd = entry.getRules(stylePropValue, componentProps.theme);
      if (rulesToAdd) {
        Object.assign(rules, rulesToAdd);
      }
    } else if ('getValue' in entry && stylePropValue !== undefined && stylePropValue !== null) {
      var props = entry.properties || [entry.styleProp];
      props.forEach(function (prop) {
        rules[prop] = entry.getValue(stylePropValue, componentProps.theme);
      });
    }
  });
  return rules;
}
function getResponsiveRules(stylePropConfig, componentProps) {
  // Get baseline styles
  var rules = getStylePropRules(stylePropConfig, componentProps, 0);
  var breakpoints = componentProps.breakpoints;
  if (!breakpoints) {
    return rules;
  }

  // If any breakpoints exist, add them to the rule set
  var bps = Array.isArray(breakpoints) ? breakpoints : [breakpoints];
  bps.forEach(function (breakpoint, index) {
    var breakpointWidth = componentProps.theme.globals.breakpoints[breakpoint] || breakpoint;
    var breakpointQuery = "@media screen and (min-width: ".concat(breakpointWidth, ")");
    rules[breakpointQuery] = getStylePropRules(stylePropConfig, componentProps, index + 1);
  });
  return rules;
}

/**
 * Takes a style prop definition and creates a style prop function that
 * can be used directly in a styled component, e.g.
 * ```
 * const MyLink = styled.a`
 *   ${myStyleProp}
 * `
 * ```
 */

function createStyleFunction(stylePropConfig, baseRules) {
  // Use StyleFunction here
  return function styleFunction(props) {
    checkTheme(props.theme);
    var rules = getResponsiveRules(stylePropConfig, props);
    if (baseRules) {
      return _objectSpread(_objectSpread({}, baseRules), rules);
    }
    return rules;
  };
}

/**
 * Returns the names (keys) of all style props in a styleProp config array
 */

function getPropNamesFromPropDefinition(propDefinition) {
  return ['breakpoints'].concat(_toConsumableArray(propDefinition.map(function (propDef) {
    return propDef.styleProp;
  })));
}

/**
 * Returns a `shouldForwardProp` function to be used in styled-components
 * to prevent any custom props from ending up in the DOM
 */

function getPropFilter(propNames) {
  var propsToFilter = new Set(propNames);
  return function shouldForwardProp(prop) {
    var key = prop;
    if (typeof key === 'number') {
      key = prop.toString();
    }
    return !propsToFilter.has(key);
  };
}
export { checkTheme, createStyleFunction, getPropFilter, getPropNamesFromPropDefinition };